import { Dayjs } from 'dayjs'
import { useRouter } from 'next/router'
import { VFC } from 'react'
import { black, truewhite } from 'src/styles/colors'
import { fontWeightBold } from 'src/styles/font'
import { lineClamp2 } from 'src/styles/mixins'
import { eventDetail } from 'src/utils/routes'
import styled from 'styled-components'
import { EventThumbnailForIndex } from './styles'

type EventItemProps = {
  openingAt: Dayjs
  name: string
  imageFile: {
    url: string
  }
  id: number
}

export const EventItemCard: VFC<{ event: EventItemProps }> = ({
  event: { openingAt, name, imageFile, id },
}) => {
  const router = useRouter()
  return (
    <EventItemLayout onClick={() => router.push(eventDetail(id))}>
      <EventThumbnailWrapper>
        <EventThumbnailForIndex>
          <img src={imageFile.url} alt="イベント" />
        </EventThumbnailForIndex>
      </EventThumbnailWrapper>
      <EventInfo>
        <Date>{openingAt.format('YYYY/M/D(ddd) H:mm')}〜</Date>
        <Title>{name}</Title>
      </EventInfo>
    </EventItemLayout>
  )
}

const EventItemLayout = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  background-color: ${truewhite};
  border-radius: 16px;
  overflow: hidden;
  cursor: pointer;
  font-weight: ${fontWeightBold};
  box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.16);
`

const EventThumbnailWrapper = styled.div``

const EventInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px 16px 32px 16px;
`

const Date = styled.p`
  color: ${black};
  letter-spacing: 0.05em;
  font-size: 12px;
`

const Title = styled.p`
  color: ${black};
  letter-spacing: 0.05em;
  line-height: 1.5;
  font-size: 14px;
  font-weight: ${fontWeightBold};
  ${lineClamp2};
`
